<template>
  <div class="account-dropdown">
    <!-- Account Trigger Button -->
    <button
      class="account-dropdown__trigger"
      :class="{ 'account-dropdown__trigger--open': isOpen }"
      type="button"
      :aria-expanded="isOpen"
      @click="toggleDropdown"
    >
      <div class="account-dropdown__trigger-avatar">
        <img v-if="userAvatar" :src="userAvatar" alt="User avatar" class="account-dropdown__trigger-avatar-img" />
        <span v-else class="account-dropdown__trigger-avatar-initials">{{ userInitials }}</span>
      </div>
      <span class="account-dropdown__trigger-text">My Account</span>
      <span class="account-dropdown__trigger-icon" :class="{ 'account-dropdown__trigger-icon--open': isOpen }">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M8.12 9.29L12 13.17L15.88 9.29L17.29 10.7L12 16L6.71 10.7L8.12 9.29Z" fill="currentColor" />
        </svg>
      </span>
    </button>

    <!-- Dropdown Panel -->
    <Teleport to="body">
      <Transition name="dropdown-fade-slide">
        <div v-if="isOpen" class="account-dropdown__panel" :style="panelStyle" @click.stop>
      <!-- User Profile Section -->
      <div class="account-dropdown__profile">
        <div class="account-dropdown__profile-avatar">
          <img v-if="userAvatar" :src="userAvatar" alt="User avatar" class="account-dropdown__profile-avatar-img" />
          <span v-else class="account-dropdown__profile-avatar-initials">{{ userInitials }}</span>
        </div>
        <div class="account-dropdown__profile-info">
          <h3 class="account-dropdown__profile-name">{{ userName }}</h3>
          <p class="account-dropdown__profile-id">Provider ID: {{ providerId }}</p>
          <p class="account-dropdown__profile-email">{{ userEmail }}</p>
        </div>
      </div>

      <!-- Menu Items -->
      <div class="account-dropdown__menu">
        <button class="account-dropdown__menu-item" @click="handleWallet">
          <div class="dropdown-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
              <path
                d="M18 4.28V2C18 0.9 17.1 0 16 0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V13.72C18.59 13.37 19 12.74 19 12V6C19 5.26 18.59 4.63 18 4.28ZM17 6V12H10V6H17ZM2 16V2H16V4H10C8.9 4 8 4.9 8 6V12C8 13.1 8.9 14 10 14H16V16H2Z"
              />
              <path
                d="M13 10.5C13.8284 10.5 14.5 9.82843 14.5 9C14.5 8.17157 13.8284 7.5 13 7.5C12.1716 7.5 11.5 8.17157 11.5 9C11.5 9.82843 12.1716 10.5 13 10.5Z"
              />
            </svg>
          </div>
          <span>Wallet & Credit</span>
        </button>

        <button class="account-dropdown__menu-item" @click="handleAssociatedPractice">
          <div class="dropdown-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="20" viewBox="0 0 16 20" fill="none">
              <path
                d="M9 4V7H12V9H9V12H7V9H4V7H7V4H9ZM14 8.2C14 4.57 11.35 2 8 2C4.65 2 2 4.57 2 8.2C2 10.54 3.95 13.64 8 17.34C12.05 13.64 14 10.54 14 8.2ZM8 0C12.2 0 16 3.22 16 8.2C16 11.52 13.33 15.45 8 20C2.67 15.45 0 11.52 0 8.2C0 3.22 3.8 0 8 0Z"
              />
            </svg>
          </div>
          <span>Associated Practice</span>
        </button>

        <!-- <button class="account-dropdown__menu-item" @click="handleBespoke">
          <div class="dropdown-item-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path
                d="M14 13C13.1667 13 12.4583 12.7083 11.875 12.125C11.2917 11.5417 11 10.8333 11 10C11 9.16667 11.2917 8.45833 11.875 7.875C12.4583 7.29167 13.1667 7 14 7C14.8333 7 15.5417 7.29167 16.125 7.875C16.7083 8.45833 17 9.16667 17 10C17 10.8333 16.7083 11.5417 16.125 12.125C15.5417 12.7083 14.8333 13 14 13ZM14 11C14.2833 11 14.5208 10.9042 14.7125 10.7125C14.9042 10.5208 15 10.2833 15 10C15 9.71667 14.9042 9.47917 14.7125 9.2875C14.5208 9.09583 14.2833 9 14 9C13.7167 9 13.4792 9.09583 13.2875 9.2875C13.0958 9.47917 13 9.71667 13 10C13 10.2833 13.0958 10.5208 13.2875 10.7125C13.4792 10.9042 13.7167 11 14 11ZM8 20V17.1C8 16.75 8.08333 16.4208 8.25 16.1125C8.41667 15.8042 8.65 15.5583 8.95 15.375C9.48333 15.0583 10.0458 14.7958 10.6375 14.5875C11.2292 14.3792 11.8333 14.225 12.45 14.125L14 16L15.55 14.125C16.1667 14.225 16.7667 14.3792 17.35 14.5875C17.9333 14.7958 18.4917 15.0583 19.025 15.375C19.325 15.5583 19.5625 15.8042 19.7375 16.1125C19.9125 16.4208 20 16.75 20 17.1V20H8ZM9.975 18H13.05L11.7 16.35C11.4 16.4333 11.1083 16.5417 10.825 16.675C10.5417 16.8083 10.2583 16.95 9.975 17.1V18ZM14.95 18H18V17.1C17.7333 16.9333 17.4583 16.7875 17.175 16.6625C16.8917 16.5375 16.6 16.4333 16.3 16.35L14.95 18ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V7C17.7333 6.66667 17.4417 6.35 17.125 6.05C16.8083 5.75 16.4333 5.55 16 5.45V2H2V16H6.15C6.1 16.1833 6.0625 16.3667 6.0375 16.55C6.0125 16.7333 6 16.9167 6 17.1V18H2ZM4 6H11C11.4333 5.66667 11.9083 5.41667 12.425 5.25C12.9417 5.08333 13.4667 5 14 5V4H4V6ZM4 10H9C9 9.65 9.0375 9.30833 9.1125 8.975C9.1875 8.64167 9.29167 8.31667 9.425 8H4V10ZM4 14H7.45C7.63333 13.85 7.82917 13.7167 8.0375 13.6C8.24583 13.4833 8.45833 13.375 8.675 13.275V12H4V14ZM2 16V2V5.425V5V16Z"
              />
            </svg>
          </div>
          <span>Bespoke Report Builder</span>
        </button> -->
      </div>

      <!-- Sign Out -->
      <div class="account-dropdown__signout">
        <button class="account-dropdown__signout-btn" @click="handleSignOut">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M10.09 15.59L11.5 17L16.5 12L11.5 7L10.09 8.41L12.67 11H3V13H12.67L10.09 15.59ZM19 3H5C3.89 3 3 3.9 3 5V9H5V5H19V19H5V15H3V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z"
            />
          </svg>
          <span>Sign Out</span>
        </button>
      </div>
      </div>
      </Transition>
    </Teleport>

    <!-- Associated Practice Dialog -->
    <AssociatedPracticeDialog
      :isOpen="showAssociatedPracticeDialog"
      @close="showAssociatedPracticeDialog = false"
    />
  </div>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
import AssociatedPracticeDialog from './AssociatedPracticeDialog.vue';
import use2FAApi from '@/views/setting/my-practice/service/Use2FAApi.js';
import { getPortalBaseUrl } from '@/utils/portalUrl';

export default {
  name: 'AccountDropdown',
  components: {
    AssociatedPracticeDialog,
  },
  setup() {
    const store = useStore();
    const { primary_email } = use2FAApi();

    const loginUserInfo = computed(() => store.state.login.userInfo);
    const providerName = computed(() => store.getters['myPractice/account/provider_name'] || '');
    
    const userName = computed(() => {
      if (providerName.value) return providerName.value;
      const info = loginUserInfo.value;
      if (info?.customer_first_name || info?.customer_last_name) {
        return [info.customer_first_name, info.customer_last_name].filter(Boolean).join(' ');
      }
      return info?.customer_name || '';
    });

    const providerId = computed(() => {
      return loginUserInfo.value?.customer_id?.toString() || '';
    });

    const userEmail = computed(() => {
      return primary_email.value || loginUserInfo.value?.email_log_in_id || '';
    });

    const userInitials = computed(() => {
      const name = userName.value || '';
      const parts = name.replace(/^Dr\.\s*/i, '').split(' ').filter(Boolean);
      if (parts.length >= 2) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
      if (parts.length === 1) return parts[0][0].toUpperCase();
      return '';
    });

    const userAvatar = computed(() => {
      return null; // No avatar provided yet
    });

    return {
      userName,
      providerId,
      userEmail,
      userInitials,
      userAvatar,
    };
  },
  data() {
    return {
      isOpen: false,
      showAssociatedPracticeDialog: false,
      triggerRect: null,
    };
  },
  computed: {
    panelStyle() {
      if (!this.triggerRect) return {};
      return {
        position: 'fixed',
        top: `${this.triggerRect.bottom + 8}px`,
        right: `${window.innerWidth - this.triggerRect.right}px`,
      };
    },
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => {
          const trigger = this.$el.querySelector('.account-dropdown__trigger');
          if (trigger) {
            this.triggerRect = trigger.getBoundingClientRect();
          }
        });
      }
    },
    handleClickOutside(event) {
      // Check if click is outside both the trigger button and the dropdown panel
      const panel = document.querySelector('.account-dropdown__panel');
      if (!this.$el.contains(event.target) && (!panel || !panel.contains(event.target))) {
        this.isOpen = false;
      }
    },
    handleWallet() {
      this.isOpen = false;
      const token = sessionStorage.getItem('token');
      const portalBaseUrl = getPortalBaseUrl();
      const url = `${portalBaseUrl}/#/wallet?jwtToken=${token}`;
      window.open(url, "_blank");
    },
    handleAssociatedPractice() {
      this.isOpen = false;
      this.showAssociatedPracticeDialog = true;
    },
    handleSignOut() {
      this.isOpen = false;
      this.$emit('sign-out');
    },
  },
};
</script>

<style scoped>
.account-dropdown {
  position: relative;
}

.dropdown-item-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Trigger Button */
.account-dropdown__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 4px 16px;
  background: #f9fbfd;
  border: 1px solid transparent;
  border-radius: 24px;
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
  box-sizing: border-box;
}

.account-dropdown__trigger:hover {
  background: #f0f4f7;
}

.account-dropdown__trigger--open {
  border-color: #004879;
  background: #f9fbfd;
}

.account-dropdown__trigger-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e0e0;
  flex-shrink: 0;
}

.account-dropdown__trigger-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.account-dropdown__trigger-avatar-initials {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.account-dropdown__trigger-text {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333;
  padding: 4px;
}

.account-dropdown__trigger-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  transition: transform 0.2s ease;
}

.account-dropdown__trigger-icon--open {
  transform: rotate(180deg);
}

/* Dropdown Panel */
.account-dropdown__panel {
  position: fixed;
  width: 300px;
  background: #f9fbfd;
  border-radius: 10px;
  box-shadow: 0px 2px 15px 0px rgba(74, 74, 74, 0.25);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 9999;
}

/* Dropdown fade and slide transitions */
.dropdown-fade-slide-enter-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.dropdown-fade-slide-leave-active {
  transition: opacity 0.5s ease, transform 0.5s ease;
}

.dropdown-fade-slide-enter-from {
  opacity: 0;
  transform: translateX(20px);
}

.dropdown-fade-slide-enter-to {
  opacity: 1;
  transform: translateX(0);
}

.dropdown-fade-slide-leave-from {
  opacity: 1;
  transform: translateX(0);
}

.dropdown-fade-slide-leave-to {
  opacity: 0;
  transform: translateX(20px);
}

/* Profile Section */
.account-dropdown__profile {
  background: #ffffff;
  border-radius: 5px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.account-dropdown__profile-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e0e0e0;
  flex-shrink: 0;
}

.account-dropdown__profile-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.account-dropdown__profile-avatar-initials {
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  font-weight: 500;
  color: #333;
}

.account-dropdown__profile-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 100%;
}

.account-dropdown__profile-name {
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: #333;
  margin: 0;
  text-align: center;
}

.account-dropdown__profile-id,
.account-dropdown__profile-email {
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0.4px;
  color: #666;
  margin: 0;
  text-align: center;
}

/* Menu Items */
.account-dropdown__menu {
  background: #ffffff;
  border-radius: 5px;
  padding: 12px 4px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.account-dropdown__menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  text-align: left;
}

.account-dropdown__menu-item svg {
  flex-shrink: 0;
  fill: #333;
  transition: fill 0.2s ease;
}

.account-dropdown__menu-item span {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #333;
  transition: color 0.2s ease;
}

.account-dropdown__menu-item:hover {
  background: rgba(0, 72, 121, 0.08);
}

.account-dropdown__menu-item:hover svg {
  fill: #004879;
}

.account-dropdown__menu-item:hover span {
  color: #004879;
}

/* Sign Out */
.account-dropdown__signout {
  background: #ffffff;
  border-radius: 5px;
  padding: 4px;
}

.account-dropdown__signout-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: transparent;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  text-align: left;
}

.account-dropdown__signout-btn svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  fill: #d10000;
  transition: fill 0.2s ease;
}

.account-dropdown__signout-btn span {
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  color: #d10000;
  transition: color 0.2s ease;
}

.account-dropdown__signout-btn:hover {
  background: rgba(246, 59, 59, 0.08);
}

.account-dropdown__signout-btn:hover svg {
  fill: #f63b3b;
}

.account-dropdown__signout-btn:hover span {
  color: #f63b3b;
}
</style>
